import React, { useContext, useEffect, useState } from 'react';
import cl from './AddCargo.module.css'   
import USD from "../../../../../assets/Icon/USD"; 
import Check from "../../../../../assets/Icon/Check"; 
import Remove from "../../../../../assets/Icon/TimeB"; 

import { AppContext } from '../../../../../providers/appProvider';
  

const AddCargoModal = ({ cargoService, containerService,defaultCargo, defaultContainer, onCloseAddCargo }) => {
 

    const cargoResetData = {
        name: "",
        personal: "",
        email: "",
        mobile: "",
        car_info: "",
        other_info: "",
        cargo_price: 0,
        vin: "",
        container_id: defaultContainer.id
    }
 
    const [searchClients, setSearchClient] = useState([])



    const handleKeyPress = (event) => {
        const keyCode = event.keyCode || event.which;
        const keyValue = String.fromCharCode(keyCode);
        const regex = /^[0-9]+$/; 
    
        if (!regex.test(keyValue)) {
          event.preventDefault();
        }
    };

 

    const handleInputChange = async (e, index) => {
        const { name, value } = e.target;
        var carTmp = cargo
        carTmp[name] = value;
        setCargo(carTmp); 
        setSearchClient([])
    };



    const handleInputInt = async (e) => {
        const { name, value } = e.target;
        var carTmp = cargo
        carTmp[name] = parseInt(value, 10); 
        setCargo(carTmp);
        setSearchClient([]);
    };
 
    const handleFocusCargo = async (e) => {
        const { name, value } = e.target; 
        if (value === '0') {
            e.target.value = '';
        }
    };

    const handleBlurCargo = async (e) => {
        const { name, value } = e.target; 
        if (value === '') {
            let val = convertToInt(0); 
            e.target.value = val;
        } 
    };
    
    function convertToInt(str) {
        const num = parseInt(str, 10);
        return isNaN(num) ? 0 : num;
    }
    

 
    const [cargo, setCargo] = useState(cargoResetData)
    const [isFirstValidated, setIsFirstValidated] = useState(false)
    const [validates, setValidates] = useState({})

    const { appState, app } = useContext(AppContext);

    const validateCargo = (cargo) => {
        const messages = {};

       

        if (cargo.name.length < 2) {
            messages['name'] = { message: 'მიუთითეთ სახელი გვარი', isValid: false };
        }

        if (cargo.vin.length < 2) {
            messages['vin'] = { message: 'მიუთითეთ ვინ-კოდი', isValid: false };
        }

        if (cargo.car_info.length < 2) {
            messages['car_info'] = { message: 'შეავსეთ ავტომობილის მონაცემები', isValid: false };
        }
 
 
        const isValid = Object.keys(messages).length === 0;
        setValidates(messages)
        return isValid;
    };

 
    useEffect(() => {
        if (isFirstValidated === true) {
            const isValidate = validateCargo(cargo)
        }
    }, [cargo, isFirstValidated]);

 
    const saveHandle = () => {

        const isValidate = validateCargo(cargo)
        
        if (isValidate === true) { 
            cargoService.add(cargo)
            .then(data => {
                //app.setOk(successMessage); 
            })
            .catch(errorMessage => {
                console.error('შეცდომა:', errorMessage);
                if (errorMessage.includes("email")) {
                    app.setError("შეცდომა: ესეთი ელ-ფოსტით უკვე არსებობს მომხმარებელი");
                } else if (errorMessage.includes("mobile")) {
                    app.setError("შეცდომა: ესეთი მობილურით უკვე არსებობს მომხმარებელი");
                } else if (errorMessage.includes("unique vin")) {
                    app.setError("შეცდომა: ესეთი VIN უკვე არსებობს");
                } else {
                    app.setError("შეცდომა: " + errorMessage);
                }
            });

            containerService.fetchList() 
            onCloseAddCargo()
        } else {
         setIsFirstValidated(true)
        }
   
    };
 
 
    return (
        <tr className={cl.tr}>
    
                <td>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '2px', position: 'relative' }} >
                        <div className={ validates && validates['name'] ? cl.groupInput + ' ' + cl.errorInput : cl.groupInput}>
                            <input type="textS" className={ cl.input }  name="name" value={cargo.name} 
                                onChange={(e) => handleInputChange(e)}
                                onInput={(e) => {
                                e.target.value = e.target.value.replace(/[^A-Za-z0-9\s]/g, '').toUpperCase();
                            }} /> 
                        </div>  
                    </div>
                </td>

                <td>
                    <div className={ validates && validates['personal'] ? cl.groupInput + ' ' + cl.errorInput : cl.groupInput }>
                        <input type="textS" className={ cl.input } name="personal" value={cargo.personal} 
                            onChange={(e) => handleInputChange(e)}
                            onInput={(e) => {
                                e.target.value = e.target.value.replace(/[^A-Za-z0-9\s]/g, '').toUpperCase();
                        }}  /> 
                    </div>
                </td>

                <td>  
                    <div className={validates && validates['mobile'] ? cl.groupInput + ' ' + cl.errorInput : cl.groupInput}> 
                        <input type="textS" className={cl.input} name="mobile" value={cargo.mobile} 
                            onChange={(e) => handleInputChange(e)}
                            onInput={(e) => {
                                e.target.value = e.target.value.replace(/[^A-Za-z0-9\s]/g, '').toUpperCase();
                        }}  />                                    
                    </div>
                </td>
 
 
                <td>
                    <div className={validates && validates[`car_info`] ? cl.groupInput + ' ' + cl.errorInput : cl.groupInput}> 
                        <input type="textS" className={cl.input}
                        onInput={(e) => {
                            e.target.value = e.target.value.replace(/[^A-Za-z0-9\s]/g, '').toUpperCase();
                        }}
                        name="car_info" value={cargo.car_info} onChange={(e) => handleInputChange(e)}   />
                    </div>
                </td>

                <td>
                    <div className={validates && validates[`vin`] ? cl.groupInput + ' ' + cl.errorInput : cl.groupInput}> 
                        <input type="textS" className={cl.input}
                        onInput={(e) => {
                            e.target.value = e.target.value.replace(/[^A-Za-z0-9\s]/g, '').toUpperCase();
                        }}
                        name="vin" value={cargo.vin} onChange={(e) => handleInputChange(e)}  />
                    </div>
                </td>

         
             
                <td style={{ maxWidth: '85px' }}>      
                    <div className={  validates && validates[`cargo_price`] ? cl.groupInput + ' ' + cl.dollar  + ' ' + cl.blue + ' ' + cl.errorInput : cl.groupInput + ' ' + cl.dollar  + ' ' + cl.blue} style={{maxWidth:'75px'}}> 
                        <div className={cl.groupInputIcon}> 
                            <input type="textS" className={cl.input}  name="cargo_price" value={cargo.cargo_price}
                                onKeyPress={handleKeyPress}   
                                onFocus={handleFocusCargo}
                                onBlur={handleBlurCargo }
                                disabled={!app.hasPermission("TRANSPORT_PRICE_ADD_CLIENT_CARGO")}
                                onChange={(e) => handleInputInt(e)} />
                        </div>
                    </div>
                </td>
   
                <td style={{ maxWidth: '85px' }}>      
                    
                </td>
 
                <td style={{ maxWidth: '85px' }}>      
                    
                </td>




                <td>
                    <span className={cl.AddBtnCargo}>
                        <span  onClick={saveHandle} >
                            <Check/>
                        </span>

                        <span onClick={onCloseAddCargo} className={ cl.removeBtn } >
                            <Remove/>
                        </span> 

                    </span>
                </td>
            
             
        </tr>
    );
};

export default AddCargoModal;